import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const TabBilanParaclinique = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));
  return (
    <div className="dn-fields">
      <div className="dn-field-group">
        <label>Bilan paraclinique <ConfidenceLabel confidence={gc("bilan_paraclinique")} /></label>
        <textarea rows={8} placeholder="Décrire le bilan paraclinique..."
          value={form.bilan_paraclinique ?? ""}
          onChange={(e) => onChange("bilan_paraclinique", e.target.value)}
          style={{ borderColor: gc("bilan_paraclinique").color || undefined }} />
      </div>
    </div>
  );
};

export default TabBilanParaclinique;